import { matchPath } from 'react-router';

import { PublicRoutingConfig } from './publicRoutingConfig';

/**
 * Whether a location is served by a route a signed-out visitor can reach.
 *
 * The config is read on call rather than at module scope: it reaches back here
 * through the login form, so at module scope it is not always evaluated yet.
 */
export const isPublicPath = (pathname: string): boolean =>
  Object.values(PublicRoutingConfig.Routes).some((route: { path: string }) =>
    // Paths are declared relative to the `/` the routes are rendered under.
    Boolean(matchPath(pathname, { path: `/${route.path}`, exact: true }))
  );
